import { useI18nStore } from '../../state/i18nStore';
import type { Locale, RawTranslations } from '../../state/types';
import { setLocale } from '../locales/actions';

import { getFeatureTranslationKey } from './shared';

const setTranslationLoadFullfilled = (id: string, strings: RawTranslations) => {
  useI18nStore.setState((state) => ({
    translations: {
      ...state.translations,
      [id]: { status: 'fulfilled', strings },
    },
  }));
};

const setTranslationLoadPending = (id: string) => {
  useI18nStore.setState((state) => ({
    translations: {
      ...state.translations,
      [id]: { status: 'pending' },
    },
  }));
};

const setTranslationLoadRejected = (id: string, error: unknown) => {
  useI18nStore.setState((state) => ({
    translations: {
      ...state.translations,
      [id]: { status: 'rejected', error },
    },
  }));
};

export interface LoadTranslationsOptions {
  readonly locale: Locale;
  readonly feature: string;
}

type LoadTranslations = (loadOptions: LoadTranslationsOptions) => Promise<void>;
export const loadTranslations: LoadTranslations = async ({ locale, feature }) => {
  const state = useI18nStore.getState();

  const featureId = getFeatureTranslationKey(locale, feature);
  const translations = state.translations;
  const translationsForFeature = translations[featureId];
  if (translationsForFeature) {
    return;
  }

  try {
    setTranslationLoadPending(featureId);
    const basePath = window.__yammer_versioned_deploy_path__ || __webpack_public_path__;
    const response = await fetch(`${basePath}yammer-locale/${locale}/${feature}.json`);

    if (!response.ok) {
      if (response.status === 404) {
        setLocale('en-us'); // Fallback to default locale
      }
      throw new Error(`${response.status} ${response.statusText}`);
    }

    const json = await response.json();
    setTranslationLoadFullfilled(featureId, json);
  } catch (error) {
    setTranslationLoadRejected(featureId, error);
    throw error;
  }
};
